// extracted by mini-css-extract-plugin
export default {"lines":"lines_lines__ZZ7PL","rotate":"lines_rotate__g93yX"};